class Header {
  constructor() {
    this._init();
  }

  _init() {

    const header = document.querySelector('header');

    if (!header) return;
    const scrollThreshold = window.innerHeight / 2;
    window.addEventListener('scroll', () => {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('sticky');
      } else if (window.scrollY == 0) {
        header.classList.remove('sticky');
      }
    });

    const burger = document.querySelector('.header__burger');
    const menu = document.querySelector('.header__menu');
    burger?.addEventListener('click', function () {
      if (burger.classList.contains('active')) {
        burger.classList.remove('active');
        menu?.classList.remove('active');
        header?.classList.remove('active');
        document.body.style.overflow = "";
      } else {
        burger.classList.add('active');
        menu?.classList.add('active');
        header?.classList.add('active');
        document.body.style.overflow = "hidden";
      }
    });
  }

}

export const header = new Header();
